<template>
  <div class="welcome">
    <h1 class="welcome__message" data-test-selector="welcome-message">
      {{ $t('welcome.welcomeMessage') }}
    </h1>
    <small class="welcome__version">{{ $t('welcome.appVersion', { version: appVersion }) }}</small>
    <h2 class="welcome__description" data-test-selector="welcome-description">
      {{ $t('welcome.appDescription') }}
    </h2>
    <div class="welcome__paragraph" data-test-selector="welcome-paragraph">
      <common-button
        id="login-button"
        data-test-selector="login-button"
        primary
        @click.prevent="loginWithAuth0"
      >
        {{ $t('welcome.loginButton') }}
      </common-button>
    </div>
  </div>
</template>

<script>
import { FOODIE_VERSION } from '@/constants';
import CommonButton from '@/components/common/CommonButton';

export default {
  name: 'Welcome',
  components: {
    CommonButton,
  },
  data() {
    return {
      appVersion: FOODIE_VERSION,
    };
  },
  methods: {
    loginWithAuth0() {
      this.$auth0.login();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.welcome {
  color: #070707;
  font-family: Avenir;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  &__message {
    font-size: 48px;
    margin-bottom: 15px;
    display: block;
  }
  &__version {
    color: $first-login-modal-button-background;
    font-weight: bolder;
  }
  &__description {
    margin-top: 15px;
    margin-bottom: 80px;
    height: 33px;
    font-size: 24px;
    font-weight: 500;
  }
  &__paragraph {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: normal;
    height: 100%;
  }
}
#login-button {
  margin: 40px 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WelcomePage.vue